<app-menu
  class="no-print"
  *ngIf="!isPrintMode"
></app-menu>
<ng-content></ng-content>
<loader
  class="no-print"
  *ngIf="!isPrintMode"
></loader>
<message
  class="no-print"
  *ngIf="!isPrintMode"
></message>
<modal
  class="no-print"
  *ngIf="!isPrintMode"
></modal>
